import React from "react";

export default function AuditLoadingSkeleton() {
  return (
    <div className="space-y-3">
      {[1, 2, 3].map((i) => (
        <div key={i} className="rounded-xl border border-[#E2E8F0] p-4">
          <div className="flex items-center gap-3">
            <div className="h-5 w-16 animate-pulse rounded-full bg-[#E2E8F0]" />
            <div className="h-4 w-20 animate-pulse rounded bg-[#E2E8F0]" />
          </div>
          <div className="mt-3 h-24 animate-pulse rounded-lg bg-[#F6F8FB]" />
        </div>
      ))}
    </div>
  );
}
